import React, { ReactElement } from 'react';

import { CrossSell } from '../../../components/CrossSell';
import { PageProperties, SeoEventType } from '../../../types';
import { toSentenceCase } from '../../../modules/formatting';
import { SliceLayout } from '../../../components/SliceLayout';

interface CrossVerticalsProps {
  pageProperties: PageProperties;
}

export function VerticalLinksV2({
  pageProperties,
}: CrossVerticalsProps): ReactElement {
  const { pageContent, inLocation, inDefaultLocation } = pageProperties;
  const { seoTag, crossVerticals, eventTypes } = pageContent;

  if (!crossVerticals?.length) return null;

  const verticals = crossVerticals.map(crossVertical => {
    const heading = getHeading(
      crossVertical.verticalName,
      seoTag,
      inLocation,
      eventTypes
    );
    return {
      ...crossVertical,
      heading,
      description: getDescription(
        crossVertical.verticalName,
        inLocation,
        inDefaultLocation
      ),
      cta: heading,
      href: crossVertical.href,
    };
  });

  return (
    <SliceLayout backgroundColor="white">
      <CrossSell items={verticals} />
    </SliceLayout>
  );
}

const getHeading = (
  seoVertical: string,
  seoTag: string,
  inLocation: string,
  eventTypes: SeoEventType[]
) => {
  return eventTypes.length === 1
    ? `${eventTypes[0].name} ${seoVertical.toLowerCase()} ${inLocation}`
    : seoTag
    ? `${toSentenceCase(seoTag)} ${seoVertical.toLowerCase()} ${inLocation}`
    : `${seoVertical} ${inLocation}`;
};

const getDescription = (
  seoVertical: string,
  inLocation: string,
  inDefaultLocation: string
) => {
  return `Looking for incredible ${seoVertical.toLowerCase()} ${inLocation ||
    inDefaultLocation}?`;
};
